/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import { useId } from 'react';

function AddressSameAsRadio({ isShow, type, onClick }) {
    const labelId = useId();
    if (!isShow) return null;
    return (
        <label
            htmlFor={labelId}
            className="inline-flex items-center justify-start text-sm text-primary"
            onClick={(e) => onClick(e, type)}
            role="button"
        >
            <input
                type="radio"
                id={labelId}
                name="AddressType"
                value={type}
                className="w-4 h-4 text-primary border border-primary rounded-md"
            />
            <span className="ml-2 capitalize">{type}</span>
        </label>
    );
}

export default AddressSameAsRadio;
